import { Button, Empty, Select, Segmented, Input, Dropdown, Menu } from "antd";
import axios from "../../utils/axios";
import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import AllCustomerTable from "../../components/SalesAgent/Table/AllCustomerTable";
import AllCustomerCard from "../../components/SalesAgent/Table/AllCustomerCard";
import TableSkimmer from "../../components/TableSkimmer";
import { channelController } from "../../controllers/channelController";
import { customerFilterData } from "./data";
import ProjectSiteMeters from "../../components/ManageMeter/ProjectSiteMeters";
import CustomerMeterDetails from "../../components/SalesAgent/Modals/CustomerMeterDetails";
import { useSelector } from "react-redux";
import CustomerWithoutMeteTable from "../../components/CustomerManager/Tables/CustomerWithoutMeteTable";
import Rule from "../../components/Rule/Index";
import { errorBlock } from "../../controllers/errorBlock";
import AssignMeter from "../../components/Meter/modals/AssignMeter";
import { useSearchParams } from "react-router-dom";
import CreateCustomerSegment from "../../components/Customer/Modal/CreateCustomerSegment";
import CustomerSegmentTable from "../../components/Customer/Table/CustomerSegmentTable";
import BulkCustomerUpload from "../../components/Customer/Modal/BulkCustomerUpload";

const ManagerMeter = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [tabstate, settabstate] = useState(1);

  useEffect(() => {
    settabstate(
      searchParams.get("tab") == 2
        ? 2
        : searchParams.get("tab") == 3
        ? 3
        : searchParams.get("tab") == 1
        ? 1
        : 1
    );
  }, [searchParams.get("tab")]);
  const [data, setData] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState("");
  const [columnInput, setColumnInput] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modal, setmodal] = useState(false);
  const [details, setdetails] = useState(null);
  const [sitename, setsitename] = useState("");

  const projectsiteName = useSelector((state) => state.projectSite).sitename;
  const projectsiteId = useSelector((state) => state.projectSite).siteid;
  const { role } = useSelector((state) => state.userDetails);

  const [search, setSearch] = useState("");
  const [dropDown, setDropDown] = useState([]);
  const [meter, setMeter] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [addsegment, setaddsegment] = useState(false);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);

  const { Option } = Select;
  const controller = new AbortController();

  // get all meter customers
  useEffect(() => {
    (async () => {
      try {
        // 7654
        // if (!(columnInput && selectedColumn)) return;
        let res;
        setLoading(true);

        if (tabstate == 1) {
          res = await axios.post("/customer/getallmetercustomersbyzone", {
            zone: projectsiteId,
          });
        } else if (tabstate == 2) {
          res = await axios.post(
            "/customer/getallcustomeraccountswithoutmeter",
            {
              // zone: projectsiteId,
            }
          );
        } else {
          res = await axios.post("/segment/getall", {
            siteid: projectsiteId,
          });
        }

        let result = channelController(res);
        if (result.type !== "success") {
          toast.error(result.message);
          setLoading(false);
          return;
        }

        if ("segments" in result.message) {
          setData(result.message.segments);
        } else {
          setData(result.message.body);
        }

        // console.log(result.message, "data");
        setLoading(false);
        // 3456
      } catch (err) {
        toast.error(err.message);
        setLoading(false);
        // 3456
      }
    })();

    return () => {};
  }, [refresh, tabstate]);

  // get all site details
  useEffect(() => {
    (async () => {
      try {
        let res = await axios.post("/sitemanagement/getallsitesdetails", {});
        let result = channelController(res);
        if (result.type !== "success") {
          toast[result.type](result.message);
          return;
        }
        setDropDown(result.message.body.map((item) => item.sitename));
      } catch (err) {
        toast.error(err.message);
      }
    })();
    return () => {
      controller.abort();
    };
  }, []);

  return (
    <Layout>
      {addsegment && (
        <CreateCustomerSegment
          visible={addsegment}
          onCancel={() => setaddsegment(false)}
        />
      )}
      {bulkUploadModal && (
        <BulkCustomerUpload
          visible={bulkUploadModal}
          onCancel={() => setBulkUploadModal(false)}
          onUploadSuccess={() => {
            setRefresh(!refresh);
            setBulkUploadModal(false);
          }}
        />
      )}
      <div className="bg-white rounded-md drop-shadow-md p-2">
        <div className="flex items-center justify-between">
          <PageTitle
            title={`Customer details in ${projectsiteName}`}
            caption={""}
          />
          <div className="flex items-center gap-2">
            <div className="!w-[250px]">
              {/*  */}
              <Input.Search
                placeholder="Search for customer"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
              />
            </div>
            {/* <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="single"
                    onClick={() => console.log("Add single customer")}
                  >
                    Add Single Customer
                  </Menu.Item>
                  <Menu.Item
                    key="multiple"
                    onClick={() => setBulkUploadModal(true)}
                  >
                    Add Multiple Customers
                  </Menu.Item>
                </Menu>
              }
              placement="bottomRight"
            >
              <Button type="primary">Add Customer</Button>
            </Dropdown> */}
          </div>
        </div>
        <Rule />
        <div className="">
          <div className="flex  items-center justify-between mt-2">
            <div className="">
              <Segmented
                value={tabstate}
                onChange={(value) => settabstate(value)}
                options={[
                  {
                    label: "Customers with meters",
                    value: 1,
                  },
                  {
                    label: "Customers without meter",
                    value: 2,
                  },
                  ...(role === "Project Manager" || role === "Customer Manager"
                    ? [
                        {
                          label: "Customer Segments",
                          value: 3,
                        },
                      ]
                    : []),
                ]}
              />
            </div>
            {/* <>
            
            </> */}
            {tabstate == 3 && (
              <Button
                type="primary"
                className="!border-1 !outline-none !hover:text-black"
                onClick={() => setaddsegment(true)}
              >
                Create Customer segments
              </Button>
            )}
          </div>
          <hr className="mt-2" />
          {tabstate == 1 && (
            <div className="">
              <hr />
              <div className="">
                {loading ? (
                  <TableSkimmer entries={10} col={7} />
                ) : data.length == 0 ? (
                  <div className="h-[70vh] flex items-center justify-center">
                    <Empty description={"No record found"} />
                  </div>
                ) : (
                  <div>
                    {/* Table view for medium screens and above */}
                    <div className="hidden md:block overflow-y-hidden overflow-x-auto">
                      <AllCustomerTable
                        data={
                          search.trim()
                            ? data.filter((item) =>
                                Object.keys(item).some(
                                  (key) =>
                                    item[key] &&
                                    item[key]
                                      .toString()
                                      .toLowerCase()
                                      .includes(search.toLowerCase())
                                )
                              )
                            : data
                        }
                        setdetails={setdetails}
                        setmodal={setmodal}
                        setRefresh={setRefresh}
                      />
                    </div>
                    {/* Card view for small screens */}
                    <AllCustomerCard
                      data={
                        search.trim()
                          ? data.filter((item) =>
                              Object.keys(item).some(
                                (key) =>
                                  item[key] &&
                                  item[key]
                                    .toString()
                                    .toLowerCase()
                                    .includes(search.toLowerCase())
                              )
                            )
                          : data
                      }
                      setdetails={setdetails}
                      setmodal={setmodal}
                      setRefresh={setRefresh}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          {tabstate == 2 && (
            <CustomerWithoutMeteTable
              data={
                search.trim()
                  ? data.filter((item) =>
                      Object.keys(item).some(
                        (key) =>
                          item[key] &&
                          item[key]
                            .toString()
                            .toLowerCase()
                            .includes(search.toLowerCase())
                      )
                    )
                  : data
              }
              refreshBtn={setRefresh}
            />
          )}
          {(role === "Customer Manager" || role === "Project Manager") &&
            tabstate === 3 &&
            (data.length == 0 ? (
              <div className="flex h-[60vh] items-center justify-center">
                <div className="flex flex-col w-[400px] items-center justify-center">
                  <h1 className="text-center text-2xl font-semibold">
                    Customer Segment
                  </h1>
                  <p className="text-center ">
                    Click on the button below to start creating customer
                    segments and manage them effectively.
                  </p>
                  <Button
                    type="primary"
                    className="!border-1 !outline-none !hover:text-black"
                    onClick={() => setaddsegment(true)}
                  >
                    Create Customer segments
                  </Button>
                </div>
              </div>
            ) : (
              <CustomerSegmentTable
                segmentData={
                  search.trim()
                    ? data.filter((item) =>
                        Object.keys(item).some(
                          (key) =>
                            item[key] &&
                            item[key]
                              .toString()
                              .toLowerCase()
                              .includes(search.toLowerCase())
                        )
                      )
                    : data
                }
                refresh={setRefresh}
              />
            ))}
        </div>
      </div>
    </Layout>
  );
};

export default ManagerMeter;
